import React, { useId } from "react";
import { createPortal } from "react-dom";
import CookieBanner from "../../CookieBanner";
import { useCookieConsent } from "../../../hooks/useCookieConsent";
import "./PartnerCookieNotice.css";

export default function PartnerCookieNotice() {
  const titleId = useId();
  const {
    consent,
    isLoading,
    showBanner,
    showExpanded,
    acceptAll,
    rejectAll,
    toggleExpanded,
    closeBanner,
  } = useCookieConsent();

  if (isLoading || !showBanner) return null;
  if (showExpanded) return <CookieBanner />;
  if (typeof document === "undefined") return null;

  return createPortal(
    <section className="partner-cookie-notice" aria-labelledby={titleId}>
      <div className="partner-cookie-notice__heading">
        <h2 id={titleId}>Your cookie choices</h2>
        {consent && (
          <button
            className="partner-cookie-notice__close"
            type="button"
            onClick={closeBanner}
            aria-label="Close cookie settings"
          >
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="m5 5 10 10M15 5 5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        )}
      </div>
      <p>
        We use essential cookies to run 22NIGHT. You can choose whether to allow
        optional analytics and marketing cookies.
      </p>
      <div className="partner-cookie-notice__actions">
        <button type="button" onClick={acceptAll}>Accept all</button>
        <button type="button" onClick={rejectAll}>Reject optional</button>
      </div>
      <div className="partner-cookie-notice__links">
        <button type="button" onClick={toggleExpanded}>Manage preferences</button>
        <a href="/privacy">Privacy policy</a>
      </div>
    </section>,
    document.body
  );
}
